import axios from 'axios';

var injected = {
  BACKEND_URL: null,
  source: '',
  getTokens: null,
  getIdToken: null,
  getRefreshToken: null,
  setAuthorization: function setAuthorization(token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  }
};

export default injected;
//# sourceMappingURL=injected.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/injected.js
// module id = 218
// module chunks = 0